import { getCostCenters } from '@lib/api'
import { costCentersKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const useCostCenters = () => {
  return useQuery(costCentersKeys.all, () => getCostCenters())
}
